import React from 'react';
import Layout from '../../component/Layout';
import MicrosoftSsoIntegrationGuide from '../../component/MicrosoftSsoIntegrationGuide';

const MicrosoftSsoIntegrationGuideContainer = () => {
	return (
		<Layout
			title='Microsoft Entra ID SSO Integration Guide'
			description='Multi-tenant admin consent flow setup steps, Microsoft documentation references, and comparison of integration options.'
		>
			<MicrosoftSsoIntegrationGuide />
		</Layout>
	);
};

export default MicrosoftSsoIntegrationGuideContainer;
